import { useEffect } from "react";
import { disableScreenWakeLock, enableScreenWakeLock } from "@/lib/game/screenWakeLock";

/** Request a screen wake lock while `enabled` is true (e.g. during a launch sequence). */
export function useScreenWakeLock(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    enableScreenWakeLock();
    return () => disableScreenWakeLock();
  }, [enabled]);
}
